/**
 * No `sitemap` export, deliberately: this is a wall display, not a page of the site. It is
 * `noindex, nofollow` and nothing links to it — it is opened by URL on a screen and left running.
 *
 * It survived the cutover on `www` rather than moving to the archived host with the rest of the old
 * site (TEC-3770): the screens that run it hold the `www` URL, and an archive nobody is meant to
 * visit is the wrong home for a page that is still in daily use.
 *
 * ONE SLUG IN EVERY LOCALE, which is the exception on this site. The four translations it used to
 * carry (`contador-en-vivo`, `comptador-en-directe`, `contatore-in-diretta`) arrived in the bulk slug
 * pass of TEC-2226 and were never the URL anyone opened — the page's own copy is hardcoded English,
 * so there was never a Spanish page for a Spanish URL to name. The map still needs an entry per
 * locale: it is what puts the route on the host under a locale prefix, so dropping the other four
 * would leave `/es/live-counter` unreachable rather than leaving it untranslated.
 */
export const routeName = 'live-counter';
export const slugs: Record<string, string> = {
	en: 'live-counter',
	es: 'live-counter',
	ca: 'live-counter',
	fr: 'live-counter',
	it: 'live-counter',
};
